import THEME from "../state/theme";

export function sendEmail(name, email, phone, message, email_prefered){

  //let base_url = 'http://structurea.be/';
  return new Promise((resolve,reject) => {
    fetch( THEME.base_url + 'envoiMail.php',{
      method: 'post',
      mode: 'cors',
      headers: {
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
          },
      body: `name=${name}&email=${email}&phone=${phone}&message=${message}&email_prefered=${email_prefered}`})
      .then((response) => response.json())
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
          reject(error);
    });
  });

}
